module.exports = __webpack_public_path__ + "images/emoji/ok_hand.6384193fe65b5cf61dac.png";